var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179.823,
    height: 155,
    viewBox: "0 0 179.823 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.n{fill:#d81212;}.b,.m{fill:#6d8aa2;}.c{fill:#e6e9ed;}.d{fill:#766a6a;}.e{fill:#504242;}.f{fill:#4c535c;}.g{fill:#fff;}.h{fill:#656d78;}.i{fill:#e8d1b3;}.i,.j,.k,.l,.m,.n,.o,.p,.q,.r{fill-rule:evenodd;}.j{fill:#16232c;}.k{fill:#adadad;}.l{fill:#dedede;}.o{fill:#ffd9c9;}.p{fill:#6f6571;}.q{fill:#d9d9d9;}.r{fill:#cbc7cb;}.s{fill:#8e1717;}.t{fill:#f0f0f0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-69.399 -148.598)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.399 148.598)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.048,36.431A3.046,3.046,0,0,1,31,33.381V24.709a3.049,3.049,0,0,1,6.1,0v8.672A3.046,3.046,0,0,1,34.048,36.431Z",
    transform: "translate(29.984 18.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39,45.5H63.394V72.942H39Z",
    transform: "translate(46.38 67.301)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39,36.5H63.394V63.942H39Z",
    transform: "translate(46.38 48.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17,36.5H71.887V66.991H17Z",
    transform: "translate(1.296 48.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22,9.5H82.986V49.143H22Z",
    transform: "translate(11.542 -6.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M128.873,25.5v6.092H13V25.5H128.873Z",
    transform: "translate(-6.901 26.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M139.07,36.648H11L17.1,27.5H132.971Z",
    transform: "translate(-11 30.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M139.07,30.5v6.092H11V30.5Z",
    transform: "translate(-11 36.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M77.035,90.434H25.2v9.148H13V32.5H128.873V99.582h-12.2V44.7H92.281V99.582h-12.2V90.434Zm3.049-15.246V44.7H25.2V75.188Z",
    transform: "translate(-6.901 40.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M18.2,51.5H72.912a1.529,1.529,0,0,1,1.525,1.525v6.1a1.529,1.529,0,0,1-1.525,1.525H18.025A1.529,1.529,0,0,1,16.5,59.121v-6.1A1.529,1.529,0,0,1,18.025,51.5Z",
    transform: "translate(0.271 79.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.042,54.239H24.047A3.046,3.046,0,0,1,21,51.19V11.555a3.046,3.046,0,0,1,3.049-3.049H85.042a3.046,3.046,0,0,1,3.049,3.049V51.19A3.046,3.046,0,0,1,85.042,54.239ZM27.1,48.141h54.9V14.6H27.1Z",
    transform: "translate(9.489 -8.506)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M72.912,69.536H18.025A1.523,1.523,0,0,1,16.5,68.011V37.519a1.527,1.527,0,0,1,1.525-1.525H72.912a1.527,1.527,0,0,1,1.525,1.525V68.011A1.523,1.523,0,0,1,72.912,69.536ZM19.549,66.487H71.387V39.043H19.549Z",
    transform: "translate(0.271 47.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M64.419,93.93H40.025A1.523,1.523,0,0,1,38.5,92.406V37.519a1.527,1.527,0,0,1,1.525-1.525H64.419a1.527,1.527,0,0,1,1.525,1.525V92.406A1.523,1.523,0,0,1,64.419,93.93Zm-22.87-3.049H62.894V39.043H41.549Z",
    transform: "translate(45.355 47.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M64.419,48.043H40.025a1.525,1.525,0,1,1,0-3.049H64.419a1.525,1.525,0,1,1,0,3.049Z",
    transform: "translate(45.355 66.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M125.818,30.6H16.05a3.049,3.049,0,1,1,0-6.1H125.818a3.049,3.049,0,0,1,0,6.1Z",
    transform: "translate(-6.899 24.266)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M157.077,59.593H2.493a3.111,3.111,0,0,1,0-6.1H157.077a3.111,3.111,0,0,1,0,6.1Z",
    transform: "translate(2.041 83.687)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.129 224.242)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M382.021,228.265h21.348v7.416a3.338,3.338,0,0,1-3.329,3.331h-7.679l-4.58,2.314-5.76-2.314V228.265Z",
    transform: "translate(-319.276 -193.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M385.351,162.742h14.691a3.338,3.338,0,0,1,3.329,3.331v5.511H382.022v-5.511A3.338,3.338,0,0,1,385.351,162.742Z",
    transform: "translate(-319.277 -138.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M382.022,206.463H403.37V211.7H382.022Z",
    transform: "translate(-319.277 -174.921)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M252.777,293.7h10.341v4.757a2.079,2.079,0,0,1-2.072,2.074H227.377c0-2.99,0-4.512,2.288-4.512l4.556,0c2.868,0,4.748-.739,5.8-2.314h12.757Z",
    transform: "translate(-190.032 -247.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M160.6,335.289h29.607c1.736,3.024,3.132,6.658,1.928,13.608-2.014-6.855-22.475-4.118-24.576,3.792H144.988c-.854-1.934-1.66-3.845-2.365-5.774h6.365C161.861,342.057,157.722,344.222,160.6,335.289Z",
    transform: "translate(-119.198 -282.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M237.09,132.918a48.327,48.327,0,0,0,1.712,6.562l6.508,2.55,7.257-2.55c-.254-13.733-5.386-20.319-9.751-22.45a10.6,10.6,0,0,0-3.185-1.649s-2.12,3.391-2.23,3.391a18.217,18.217,0,0,0-1.07,7.2Z",
    transform: "translate(-197.511 -98.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M229.192,262.108H215.427c-3.17.346-7.07,2.76-7.07,10.239v7.839l3.124,1.861,4.061-1.861v-6.058c0-2.99,0-4.512,2.288-4.512l4.556,0c2.868,0,4.748-.739,5.8-2.314A8.495,8.495,0,0,0,229.192,262.108Z",
    transform: "translate(-174.136 -221.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M294.474,376.333a12.551,12.551,0,0,1,24.576-3.792,12.873,12.873,0,0,1,.552,3.389c.014.461-.3.4-.734.4Q306.673,376.333,294.474,376.333Z",
    transform: "translate(-246.108 -306.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M313.718,441.231h19.128a9.569,9.569,0,0,1-19.128,0Z",
    transform: "translate(-262.192 -371.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M16.884,428.81,33.34,432.6a8.443,8.443,0,1,1-16.456-3.787Z",
    transform: "translate(-13.93 -360.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1.722,375.375a11.486,11.486,0,0,1,10.585-4.925c7.444,1.574,9.866,6.024,10.35,11.573a11.47,11.47,0,0,1-.254,2.271c-.048.211-.187.125-.417.072l-2.576-.59L2.954,379.988,1.722,379.7,0,379.306a11.4,11.4,0,0,1,1.722-3.931Z",
    transform: "translate(0 -311.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M74.845,246.761l6.648-23,2.993-1.339,3.348,1.339c-4.4,12.192-3.17,20.7-.2,28.825.71,1.93,1.516,3.84,2.365,5.774H85.215Z",
    transform: "translate(-62.552 -188.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M197.593,65.095l7.8-1.661c.791.072,3.055,1.973,3.055,3.163l-1.66,8.439a7.617,7.617,0,0,1-2.182.322,7.541,7.541,0,0,1-7.012-10.263Z",
    transform: "translate(-164.715 -55.384)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M184.849,24.134a9.5,9.5,0,1,1,18.993,0,10.162,10.162,0,0,1-4.048,8.52,9.059,9.059,0,0,1-3.233,1.421V25.636c0-1.19-.6-1.43-1.4-1.5H184.849Z",
    transform: "translate(-154.489 -14.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M185.751,372.171h7.185V376.7c0,.97-.528,1.042-1.3,1.042H181.319C181.113,373.2,183.861,372.171,185.751,372.171Z",
    transform: "translate(-151.529 -313.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M97.654,184.864l8.974,2.966c.441.394-.057,4.407-.355,4.277H95.841v-6.6C95.841,184.2,96.517,184.49,97.654,184.864Z",
    transform: "translate(-80.1 -156.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M154.676,207.1h-4.537c-2.437,0-2.509-4.042.355-4.277l4.182-.336,1.122,2.376Z",
    transform: "translate(-123.965 -171.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M195.092,168.256l1.5-1.291c3.76-3.24,8.513,2.227,3.487,5.491l-4.23,2.746-2.13,1.382h-6.739v-4.613l4.187-.341Z",
    transform: "translate(-156.271 -141.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M238.536,219.771Z",
    transform: "translate(-198.957 -185.652)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M224.917,240l-.911,12.8c-.011.242.181.476.533.648a3.088,3.088,0,0,0,1.331.265h1.743a3.088,3.088,0,0,0,1.331-.265c.351-.172.544-.406.533-.648l-.911-12.8Z",
    transform: "translate(-84.398 -63.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M203.648,48.625V45.889L200,44.977S200.912,24,207.3,24V48.625Z",
    transform: "translate(-63.129 128.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M80.917,176l-.911,20.8a.972.972,0,0,0,.533.825,2.533,2.533,0,0,0,1.331.337h1.742a2.533,2.533,0,0,0,1.331-.337.972.972,0,0,0,.533-.825L84.565,176Z",
    transform: "translate(44.376 -6.942)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M72.148,24a.933.933,0,0,0-.852.941v9.09H69.472V24.943A.933.933,0,0,0,68.621,24a.912.912,0,0,0-.973.91v9.121H65.824v-9.09A.933.933,0,0,0,64.972,24a.912.912,0,0,0-.972.91V36.464a3.648,3.648,0,0,0,.73,2.189l2.007,2.675h3.648l2.007-2.675a3.648,3.648,0,0,0,.73-2.189V24.911a.912.912,0,0,0-.972-.91Z",
    transform: "translate(58.557 127.729)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus3);
export default __webpack_public_path__ + "static/media/status-3.59e9089d4f138293973a10d90f284897.svg";
export { ForwardRef as ReactComponent };